/**
 * Chat draft shown in the main textarea and used for Send.
 * When a mandate prompt is applied, appliedMandateText is the source of truth
 * (the green session preview and chat box stay in sync).
 */
export function resolveEffectiveChatDraft({
  mandatePromptId,
  appliedMandateText = '',
  inputMessage = '',
}) {
  const applied = (appliedMandateText || '').trim();
  if (applied) {
    return appliedMandateText;
  }
  return inputMessage;
}

/**
 * Resolve prompt body for the main chat textarea after Apply to session.
 * Mandate prompts and report prompts (e.g. Stage 1 chat steps) both load here.
 */
export function resolveAppliedSessionChatText(data, prompt, libraryEntries = []) {
  const appliedCategory = (data?.category || prompt?.category || 'mandate').trim().toLowerCase();
  const libraryMatch = (libraryEntries || []).find(
    (item) => item.id === (data?.prompt_id || prompt?.id),
  );
  if (appliedCategory === 'report') {
    return (
      data?.chat_prompt
      || data?.prompt_text
      || data?.report_instructions
      || data?.prompt?.content
      || prompt?.content
      || libraryMatch?.content
      || ''
    ).trim();
  }
  return (
    data?.prompt_text
    || data?.chat_prompt
    || data?.prompt?.content
    || prompt?.content
    || libraryMatch?.content
    || ''
  ).trim();
}

/**
 * @deprecated Use resolveAppliedSessionChatText for apply handlers.
 */
export function resolveAppliedChatPrompt(data, prompt, libraryEntries = []) {
  const appliedCategory = (data?.category || prompt?.category || 'mandate').trim().toLowerCase();
  if (appliedCategory === 'report') return '';
  return resolveAppliedSessionChatText(data, prompt, libraryEntries);
}
